import React from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import DashboardCard, {
    ChartBody,
    ChartEmpty,
    ChartPlot,
    ChartTooltip,
    chartSemanticColor,
    formatChartCurrency,
} from './DashboardCard';

interface SalesByChannelChartProps {
    data: { name: string; value: number }[];
}

const SalesByChannelChart: React.FC<SalesByChannelChartProps> = ({ data }) => {
    const chartData = data.map((item, index) => ({
        ...item,
        color: chartSemanticColor(index),
    }));

    return (
        <DashboardCard title="Vendas por canal">
            {chartData.length === 0 ? (
                <ChartEmpty>Sem vendas neste período.</ChartEmpty>
            ) : (
                <ChartBody>
                    <ChartPlot>
                        <PieChart>
                            <Pie
                                data={chartData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius="62%"
                                outerRadius="88%"
                                paddingAngle={4}
                                stroke="none"
                            >
                                {chartData.map((entry) => (
                                    <Cell key={entry.name} fill={entry.color} />
                                ))}
                            </Pie>
                            <Tooltip content={<ChartTooltip formatValue={formatChartCurrency} />} />
                        </PieChart>
                    </ChartPlot>
                    <ul className="flex max-h-16 flex-wrap justify-center gap-x-s3 gap-y-s1 overflow-y-auto pt-s3 scrollbar-premium">
                        {chartData.map((item) => (
                            <li key={item.name} className="flex items-center gap-s1 text-sm text-muted">
                                <span
                                    className="size-2 shrink-0 rounded-full"
                                    style={{ backgroundColor: item.color }}
                                />
                                <span className="max-w-[9rem] truncate" title={item.name}>
                                    {item.name}
                                </span>
                                <span className="font-mono text-xs tabular-nums">
                                    {formatChartCurrency(item.value)}
                                </span>
                            </li>
                        ))}
                    </ul>
                </ChartBody>
            )}
        </DashboardCard>
    );
};

export default SalesByChannelChart;
